import { Component, input } from '@angular/core';
import { getColorClasses } from '../../helpers';

@Component({
  selector: 'app-color-total',
  imports: [],
  templateUrl: './color-total.component.html',
  styles: ``,
})
export class ColorTotalComponent {
  color = input<string>('');
  total = input<number>();

  getColorClass() {
    return getColorClasses(this.color());
  }
}
